var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loan-index-page"},[_c('router-view'),_c('div',{staticClass:"map",staticStyle:{"display":"none"},attrs:{"id":"map"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }